import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaHardHat, FaClipboardCheck, FaUsers, FaAward } from 'react-icons/fa';
import { HiOutlineBuildingStorefront, HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { BsBuildings, BsClipboard2Check  } from "react-icons/bs";
import heroVideo from '../assets/images/hero-video.mp4';
import '../styles/Home.css';

const Home = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: <BsClipboard2Check />,
      title: t('services.projectManagement'),
      description: t('services.projectManagementDesc')
    },
    {
      icon: <HiOutlineBuildingOffice2 />,
      title: t('services.residential'),
      description: t('services.residentialDesc')
    },
    {
      icon: <HiOutlineBuildingStorefront />,
      title: t('services.commercial'),
      description: t('services.commercialDesc')
    },
    {
      icon: <BsBuildings />,
      title: t('services.renovations'),
      description: t('services.renovationsDesc')
    }
  ];

  const whyChooseUs = [
    {
      icon: <FaAward />,
      title: t('whyChoose.experience'),
      description: t('whyChoose.experienceDesc')
    },
    {
      icon: <FaClipboardCheck />,
      title: t('whyChoose.quality'),
      description: t('whyChoose.qualityDesc')
    },
    {
      icon: <FaUsers />,
      title: t('whyChoose.reliability'),
      description: t('whyChoose.reliabilityDesc')
    }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <video
            autoPlay
            loop
            muted
            playsInline
            className='hero-video'
        >
            <source src={heroVideo} type="video/mp4" />
        </video>
        <div className="hero-overlay"></div>
        <div className="hero-content container">
            <h1 className="hero-title">{t('home.heroTitle')}</h1>
            <p className="hero-subtitle">{t('home.heroSubtitle')}</p>
            <a href="#contact" className="cta-button">
                {t('home.ctaButton')}
            </a>
        </div>            
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title text-center">{t('home.servicesTitle')}</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="container">
          <h2 className="section-title text-center">{t('home.whyChooseTitle')}</h2>
          <p className="section-subtitle text-center">{t('home.whyChooseSubtitle')}</p>
          <div className="why-choose-grid">
            {whyChooseUs.map((item, index) => (
              <div key={index} className="why-choose-card">
                <div className="why-choose-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" id="contact">
        <div className="container text-center">
          <h2>{t('about.ctaTitle')}</h2>
          <p>{t('about.ctaSubtitle')}</p>
          <a href="mailto:info@aegisconstruction.ca?subject=Construction Project Inquiry&body=Hello,%0D%0A%0D%0AI am interested in discussing a construction project.%0D%0A%0D%0AProject Type: [Residential/Commercial/Renovation]%0D%0ALocation: %0D%0ATimeline: %0D%0ABudget Range: %0D%0A%0D%0APlease contact me to schedule a consultation.%0D%0A%0D%0AThank you!" className="cta-button">
            {t('about.ctaButton')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;